import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DashboardLayout } from "../../components/DashboardLayout";
import api from "../../lib/api";
import { Search } from "lucide-react";

export default function SuperAdminPatientsListPage({ links }) {
  const [patients, setPatients] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);
  const [tagIds, setTagIds] = useState([]);

  useEffect(() => { api.get("/admin/patients/tags/catalog").then(r => setTags(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/admin/patients", { params: { q, tag_ids: tagIds.join(",") } }).then((r) => {
      setPatients(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [q, tagIds]);

  return (
    <DashboardLayout links={links} title="Global Patients">
      <div className="flex flex-wrap gap-3 items-center justify-between mb-4">
        <div className="relative w-full max-w-md">
          <Search className="w-4 h-4 absolute top-3 left-3 text-slate-400" />
          <input className="mg-input pl-9" placeholder="Search patients by name, phone or email…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <select className="mg-input max-w-xs" value="" onChange={e => e.target.value && setTagIds(ids => ids.includes(e.target.value) ? ids : [...ids, e.target.value])}>
          <option value="">Filter by organization tag…</option>
          {tags.filter(t => !tagIds.includes(t.tag_id)).map(t => <option key={t.tag_id} value={t.tag_id}>{t.display_name} — {t.organization_name}</option>)}
        </select>
        <div className="flex flex-wrap gap-1">{tagIds.map(id => { const tag = tags.find(t => t.tag_id === id); return tag ? <button key={id} onClick={() => setTagIds(tagIds.filter(x => x !== id))} className="text-xs px-2 py-1 rounded-full border" style={{borderColor: tag.color, color: tag.color}}>{tag.display_name} ×</button> : null; })}</div>
        <span className="text-xs text-slate-500 font-semibold">{patients.length} patient(s)</span>
      </div>

      <div className="mg-card p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-left text-xs uppercase text-slate-500 tracking-wider">
            <tr>
              <th className="p-4">Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Clinic</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading && <tr><td colSpan="5" className="p-8 text-center text-slate-400">Loading...</td></tr>}
            {!loading && patients.map(p => (
              <tr key={p.patient_id} className="hover:bg-slate-50">
                <td className="p-4 font-semibold text-mg-navy">
                  <Link to={`/super-admin/patients/${p.patient_id}`} className="hover:text-mg-medical hover:underline">{p.name}</Link>
                  {p.tags?.length > 0 && <div className="flex gap-1 mt-1">{p.tags.map(tag => <span key={tag.tag_id} className="text-[10px] px-1.5 py-0.5 rounded-full text-white" style={{backgroundColor: tag.color}}>{tag.display_name}</span>)}</div>}
                </td>
                <td>{p.phone || "—"}</td>
                <td>{p.email || "—"}</td>
                <td><span className="text-xs bg-slate-100 px-2 py-1 rounded font-medium">{p.clinic_name || "—"}</span></td>
                <td className="text-slate-500">{new Date(p.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {!loading && patients.length === 0 && (
              <tr><td colSpan="5" className="p-8 text-center text-slate-400">No patients found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
